<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <header class="card-header no-print">
            <div class="d-flex">
              <strong class="align-self-center">Geolocalização</strong>
              <download-csv
                v-if="report && report.itens"
                title="Baixar dados planilha"
                class="ml-auto no-print"
                :data="GetCsv()"
                :separator-excel="false"
                :name="'geolocalizacao.csv'"
              >
                <button class="btn">
                  <i class="fas fa-file-excel fa-2x"></i>
                </button>
              </download-csv>
            </div>
          </header>

          <div class="card-body">
            <div class="row">
              <div class="col-sm-12 col-md-4 col-lg-3 col-xl-3">
                <div class="form-group">
                  <label for>Projeto</label>
                  <v-select
                    placeholder="Digite o nome do projeto"
                    v-model="viewModel.projects"
                    :options="[
                      { label: 'Todos', id: $store.getters.emptyGuid },
                      ...projects
                    ]"
                    multiple
                  >
                    <template slot="no-options">
                      Nenhum resultado para a busca.
                    </template>
                  </v-select>
                </div>
              </div>

              <div class="col-sm-12 col-md-4 col-lg-3 col-xl-3">
                <div class="form-group">
                  <label for>Origem</label>
                  <v-select
                    placeholder="Digite o nome da origem"
                    v-model="viewModel.origins"
                    :options="origins"
                    multiple
                  >
                    <template slot="no-options">
                      Nenhum resultado para a busca.
                    </template>
                  </v-select>
                </div>
              </div>

              <div class="col-sm-12 col-md-4 col-lg-3 col-xl-3">
                <div class="form-group">
                  <label for>Situação</label>
                  <v-select
                    placeholder="Digite o nome da situação"
                    v-model="viewModel.status"
                    :options="situations"
                    multiple
                  >
                    <template slot="no-options">
                      Nenhum resultado para a busca.
                    </template>
                  </v-select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12 col-md-4 col-lg-3 col-xl-3">
                <div class="form-group">
                  <label for>GAAU</label>
                  <v-select
                    placeholder="Digite o nome do GAAU"
                    v-model="viewModel.priority"
                    :options="priorities"
                    multiple
                  >
                    <template slot="no-options">
                      Nenhum resultado para a busca.
                    </template>
                  </v-select>
                </div>
              </div>

              <div class="col-sm-12 col-md-5 col-lg-6 col-xl-6">
                <div class="form-group">
                  <label for>Recomendação de Manejo</label>
                  <v-select
                    placeholder="Digite o nome do manejo"
                    v-model="viewModel.managers"
                    :options="['Todos', ...managers]"
                    multiple
                  >
                    <template slot="no-options">
                      Nenhum resultado para a busca.
                    </template>
                  </v-select>
                </div>
              </div>
            </div>

            <div class="row mb-5">
              <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <button class="btn btn-secondary mt-4" @click="Filter">
                  Filtrar
                </button>
              </div>
            </div>

            <div v-if="loading" class="loading-container">
              <RotateSquare
                class="loading-position animated fadeIn"
                size="60px"
              ></RotateSquare>
            </div>
            <GoogleMaps v-else :markers="markers" />

            <div class="row mt-3">
              <div class="col-md-4 col-sm-12" v-if="tableOrigins.length > 0">
                <b-table
                  :hover="true"
                  responsive
                  :items="tableOrigins"
                  :fields="fieldsOrigin"
                  striped
                  show-empty
                  empty-text="Sem valor."
                >
                  <template v-slot:empty="scope">
                    <h4>{{ scope.emptyText }}</h4>
                  </template>
                </b-table>
              </div>
              <div class="col-md-4 col-sm-12" v-if="tableStatus.length > 0">
                <b-table
                  :hover="true"
                  responsive
                  :items="tableStatus"
                  :fields="fieldsStatus"
                  striped
                  show-empty
                  empty-text="Sem valor."
                >
                  <template v-slot:empty="scope">
                    <h4>{{ scope.emptyText }}</h4>
                  </template>
                </b-table>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-sm-12" v-if="tableGaau.length > 0">
                <b-table
                  :hover="true"
                  responsive
                  :items="tableGaau"
                  :fields="fieldsGaau"
                  striped
                  show-empty
                  empty-text="Sem valor."
                >
                  <template v-slot:empty="scope">
                    <h4>{{ scope.emptyText }}</h4>
                  </template>
                </b-table>
              </div>
              <div class="col-md-4 col-sm-12" v-if="tableManager.length > 0">
                <b-table
                  :hover="true"
                  responsive
                  :items="tableManager"
                  :fields="fieldsManager"
                  striped
                  show-empty
                  empty-text="Sem valor."
                >
                  <template v-slot:empty="scope">
                    <h4>{{ scope.emptyText }}</h4>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import RotateSquare from "../../components/RotateSquare";
import ProjectService from "../../servico/ProjectService";
import DateTime from "../../util/DateTime";
import GoogleMaps from "../../components/GoogleMaps";
import CsvGaauService from "../../servico/CsvGaauService";
import GeolocationService from "../../servico/GeolocationService";
import GaauManagersEnum from "../../enums/GaauManagersEnum";
import Group from "../../util/Group";
import GaauService from "../../servico/GaauService";
import GaauPriorityEnum from "../../enums/GaauPriorityEnum";

export default {
  name: "Geolocation",
  components: {
    RotateSquare,
    DateTime,
    GoogleMaps
  },
  data() {
    return {
      loading: false,
      markers: [],
      viewModel: {
        projects: [],
        origins: [],
        status: [],
        priorities: [],
        managers: []
      },
      projects: [],
      managers: GaauManagersEnum,
      report: null,
      tableOrigins: [],
      tableStatus: [],
      tableGaau: [],
      tableManager: [],
      situations: [
        { id: "", label: "Todos" },
        { id: "Plantio", label: "Plantio" },
        { id: "Viva", label: "Viva" },
        { id: "Morta", label: "Morta" }
      ],
      origins: [
        { id: "", label: "Todos" },
        { id: "Nativa", label: "Nativa" },
        { id: "Exótica", label: "Exótica" },
        { id: "Exótica Invasora", label: "Exótica Invasora" }
      ],
      priorities: [
        { id: "All", label: "Todos" },
        { id: "Priority", label: "Prioritário" },
        { id: "High", label: "Alto" },
        { id: "Average", label: "Médio" },
        { id: "Low", label: "Baixo" }
      ],
      fieldsOrigin: [
        { key: "label", label: "Origem", sortable: true },
        { key: "value", label: "Quantidade", sortable: true }
      ],
      fieldsStatus: [
        { key: "label", label: "Situação", sortable: true },
        { key: "value", label: "Quantidade", sortable: true }
      ],
      fieldsGaau: [
        { key: "label", label: "GAAU", sortable: true },
        { key: "value", label: "Quantidade", sortable: true }
      ],
      fieldsManager: [
        { key: "label", label: "Manejo", sortable: true },
        { key: "value", label: "Quantidade", sortable: true }
      ]
    };
  },
  mounted() {
    this.GetProjects();
  },
  methods: {
    GetProjects() {
      ProjectService.GetVSelect("    ", true)
        .then((result) => {
          this.projects = result.data;
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    GetCsv() {
      return CsvGaauService.Get(this.viewModel.itens);
    },
    Filter() {
      let filter = this.MountFilter();

      this.loading = true;
      GeolocationService.GetCoordinates(filter)
        .then((result) => {
          this.markers = result.data;
          this.loading = false;
          this.GetReportTable();
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    GetCsv() {
      return CsvGaauService.Get(this.report.itens);
    },
    GetReportTable() {
      let filter = this.MountFilter();

      GeolocationService.ReportTable(filter)
        .then((result) => {
          this.report = result.data;
          this.GroupTable(result.data.itens);
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    MountFilter() {
      let filter = {
        projects: [],
        origins: [],
        status: [],
        priorities: [],
        managers: this.viewModel.managers
      };
      filter.origins =
        this.viewModel.origins?.map((item) => {
          return item.id;
        }) || [];
      filter.priorities =
        this.viewModel.priority?.map((item) => {
          return item.id;
        }) || [];
      filter.status =
        this.viewModel.status?.map((item) => {
          return item.id;
        }) || [];
      filter.projects = this.viewModel.projects.map((item) => {
        return item.id;
      });

      this.tableGaau = [];
      this.tableOrigins = [];
      this.tableStatus = [];
      return filter;
    },
    async GroupTable(itens) {
      if (!itens) return;
      let groupOrigin = Group.Execute(itens, "origin");
      this.tableOrigins = Group.Format(groupOrigin);

      let groupStatus = Group.Execute(itens, "status");
      this.tableStatus = Group.Format(groupStatus);

      itens.forEach(
        (element) =>
          (element.resultName = GaauService.ResultName(element.result))
      );
      let groupGaau = Group.Execute(itens, "resultName");
      groupGaau = Group.Format(groupGaau);
      this.tableGaau = this.FormatGaauPriority(groupGaau);
      let managers = Group.Execute(await this.GetManagers(itens), "text");

      let table = Group.Format(managers);
      let distinct = GaauManagersEnum.filter(
        (item) => !table.some((obj) => obj.label === item)
      ).map((text) => ({ label: text, value: 0 }));
      table.push(...distinct);
      this.tableManager = table;
    },
    async GetManagers(itens) {
      const arrayExterno = [].concat(...itens.map((objeto) => objeto.managers));

      let result = arrayExterno
        .filter((item) => item)
        .map((text) => ({ text }));
      return result;
    },
    FormatGaauPriority(itens) {
          let newArray = [
        { label: GaauPriorityEnum.Priority, value: 0 },
        { label: GaauPriorityEnum.High, value: 0 },
        { label: GaauPriorityEnum.Average, value: 0 },
        { label: GaauPriorityEnum.Low, value: 0 }
      ];

      for (let index = 0; index < newArray.length; index++) {
         let item = itens.find(
          (element) => element.label === newArray[index].label
        ) || { value: 0};
        
        newArray[index].value = item.value;
      }
      return newArray;
    }
  }
};
</script>
  